const COHORT_YEAR_COUNT = 7;
const COHORT_YEAR_OFFSET = -4;

export const getCohortYearRange = (currentCohortYear?: number) => {
  return currentCohortYear
    ? [...Array(COHORT_YEAR_COUNT).keys()].map(
        (num) => `${num + currentCohortYear + COHORT_YEAR_OFFSET}`,
      )
    : [];
};
